
import React, {useState, useEffect, useRef} from 'react'
import axios from 'axios';
import baseUrl from "./BaseUrl";
import {apiUrl} from "./config";

import jwt_decode from "jwt-decode";
import { useNavigate, Link } from 'react-router-dom';
import Loader from "./Loader";
 
const Navbar = (props) => {
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [toogleSidebar, setToogleSidebar] = useState(false);
    const [isNumberManagementPermission, setIsNumberManagementPermission] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [applicationList, setApplicationList] = useState([]);
    const [iframeUrl, setIframeUrl] = useState(null);
    const [token, SetToken] = useState(props.token);
    const [role, setRole] = useState('');
    const [cid, setCid] = useState('');
    const [userId, setUserId] = useState('');
    const [casAccess, setCASAccess] = useState(false);
    const [userApplicationList, setUserApplicationList] = useState([]);
    const [callPassBrandedCallingAccess, setCallPassBrandedCallingAccess] = useState(false);
    const [userCallPassBrandedCallingAccess, setUserCallPassBrandedCallingAccess] = useState(false);
    const [callPassIdentitiesAccess, setCallPassIdentitiesAccess] = useState(false);
    const [userCallPassIdentitiesAccess, setUserCallPassIdentitiesAccess] = useState(false);
    const [userCallPassExportAccess, setUserCallPassExportAccess] = useState(false);
    const [hasUptivityAccess, setHasUptivityAccess] = useState(false);
    // const [callPassSubmenuOpen, setCallPassSubmenuOpen] = useState(false);
    const toggleRef = useRef(null);
    let inactivityTimer;

    // const [userId, setUserId] = useState('');

    // useEffect(() => {
    //     // Check inactivity before adding listeners
    //     const last = parseInt(localStorage.getItem("lastActive") || "0");
    //     const now = Date.now();
    //     const diffMinutes = (now - last) / (1000 * 60);
  

    //     if (diffMinutes > 60) {
    //         console.log("🚫 Inactive too long — logging out");
    //         Logout(); // User was inactive too long
    //         return; // Do not add event listeners or start timer
    //     }

  
    //     resetTimer(); //

    //     document.addEventListener("mousemove", resetTimer);
    //     document.addEventListener("keydown", resetTimer);
    //     document.addEventListener("click", resetTimer);


    //     return () => {
    //         document.removeEventListener("mousemove", resetTimer);
    //         document.removeEventListener("keydown", resetTimer);
    //         document.removeEventListener("click", resetTimer);
    //         clearTimeout(inactivityTimer);
    //     };
    // }, []);   
    

    useEffect(() => {
        if (props.token) {
          try {
            const decoded = jwt_decode(props.token);
            setCid(decoded.cid);
            setRole(decoded.role);
            setUserId(decoded.userId);

            // Check Uptivity access from sessionStorage or API
            const cachedAccess = sessionStorage.getItem('hasUptivityAccess');
            console.log("Cached Uptivity Access:", cachedAccess);
            if (cachedAccess !== null) {
              setHasUptivityAccess(cachedAccess === 'true');
            } else {
              checkUptivityAccess();
            }
          } catch (error) {
            // Handle invalid token or decoding error
            console.error('Error decoding token:', error);
          }
        }
      }, [props.token]);
    useEffect(() => {
        if (role >=3) {
            getApplicationList();
        }
        if(cid){
            getCustomerTNSAccess();
            checkNumberManagementPermission();
            getUserAccess();
        }
    }, [role, cid]);

    const getApplicationList = async () => {
        try{
            setPopupOpen(true);
           
            const response = await axios.get(`${baseUrl}/application-name-list/${cid}`, {
                headers: {
                    Authorization: `Bearer ${props.token}`
                }
            });
            setPopupOpen(false);
            setApplicationList(response.data.data);
        }catch (error) {
            console.log(error);
            setPopupOpen(false);
        }
    }
    const resetTimer = () => {
        localStorage.setItem("lastActive", Date.now().toString());
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(() =>  Logout(),  60 * 60 * 1000); // 1 hour
    };  

    const Logout = async () => {
        try {
            setPopupOpen(true);
            localStorage.clear();
            sessionStorage.clear();
            console.log("clear");
            await axios.delete(`${baseUrl}/logout`);
            navigate("/");
        } catch (error) {
            console.log(error);
            setPopupOpen(false);
        }
    }

    const getCustomerTNSAccess = async () => {
        try {
            if(role <= 1){
                // Super admin: always full access (user-level also hardcoded 1 by backend)
                setCASAccess(true);
                setCallPassBrandedCallingAccess(true);
                setCallPassIdentitiesAccess(true);
            } else if(role === 2){
                // BBD user: no company restriction; personal switch (from getUserAccess) gates menu
                setCASAccess(true);
                setCallPassBrandedCallingAccess(true);
                setCallPassIdentitiesAccess(true);
            } else {
                // Customer user: governed by company-level switch
                const response = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                    headers: {
                        Authorization: `Bearer ${props.token}`
                    }
                });
                setCASAccess((response.data.cia_enable_switch === 1 && response.data.cia_account_type === 1 && response.data.user_enms_access === 1) ? true : false);
                setCallPassBrandedCallingAccess(response.data.call_pass_branded_calling_switch >= 1 ? true : false);
                setCallPassIdentitiesAccess(response.data.call_pass_display_identities_switch >= 1 ? true : false);
            }
        } catch (error) {
           console.log(error);
        }
    };

    const getUserAccess = async () => {
        try {
            const response = await axios.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${props.token}`
                }       
            });
            console.log(response.data)
            setUserApplicationList(response.data.user_pbx_switch);
            setUserCallPassBrandedCallingAccess(response.data.user_call_pass_branded_calling_switch == 0 ? false : true);
            setUserCallPassIdentitiesAccess(response.data.user_call_pass_display_identities_switch  == 0 ? false : true);
            setUserCallPassExportAccess(response.data.user_call_pass_export_switch == 0 ? false : true);
        } catch (error) {
           console.log(error);
        }
    }

    const checkNumberManagementPermission= async () => {
        const response = await axios.get(`${baseUrl}/check-number-management-permission`, {
            headers: {
                Authorization: `Bearer ${props.token}`
            }
        });
        setIsNumberManagementPermission(response.data.NumberManagementAccess);
    }

    const checkUptivityAccess = async () => {
        try {
            const response = await axios.get(`${baseUrl}/check-uptivity-access`, {
                headers: {
                    Authorization: `Bearer ${props.token}`
                }
            });
            const hasAccess = response.data.hasAccess || false;
            setHasUptivityAccess(hasAccess);
            sessionStorage.setItem('hasUptivityAccess', hasAccess.toString());
        } catch (error) {
            console.error('Error checking Uptivity access:', error);
            setHasUptivityAccess(false);
            sessionStorage.setItem('hasUptivityAccess', 'false');
        }
    };

    const closeIframe = () => {
        setIframeUrl(null);
    };

    const hasPermission = (permission) => {
        if (props.access && props.access.length > 0) {
            return props.access.some((item) => item.access === permission);
        }
        return false;
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const handleApplication = (e,url) => {
        e.preventDefault();
        setIframeUrl(url);
    }

    const handleToogleSidebar = () => {
        const value = !toogleSidebar;
        
        if (toggleRef.current) {
            const parentElement = toggleRef.current.closest('.panelbox');
            if (value && parentElement) {
                parentElement.classList.add('collaps-wrap'); // Add class to parent
            }
            if(!value && parentElement){
                parentElement.classList.remove('collaps-wrap'); // Add class to parent
            }
        }
        setToogleSidebar(value);
    }
    return (
        
        <div className={`${toogleSidebar ? "collaps-sidebar" : ""} left-sidebar`}>
            {popupOpen && (
                     <Loader /> 
                ) }
        <div className="logo-div">
            <img src={`${process.env.PUBLIC_URL}/images/innerlogo.png`} alt='' />
            {/* <div> */}
            <a href="#" ref={toggleRef} onClick={handleToogleSidebar}><img src={`${process.env.PUBLIC_URL}/images/menubar.png`} alt="" /></a>
            {/* </div> */}
        </div>
        <div className="mainmenu" style={mobileMenuOpen ? {display: 'block'}: {}}>
            <div className="mobilemenu-close">
                <a href="#" onClick={toggleMobileMenu}><img src={`${process.env.PUBLIC_URL}/images/close_white.png`} alt="" /></a>
            </div>
            <ul>
                <li>
                    <Link to="/dashboard"><img src={`${process.env.PUBLIC_URL}/images/layers.png`} alt='' /> <span>Dashboard</span></Link>
                </li>
                {role !== 5 && hasPermission('viewuser') && <li>
                    <Link to="/user"><img src={`${process.env.PUBLIC_URL}/images/bx-user.png`} alt='' /> <span>User Management</span></Link>
                </li>}
                {(role !== 4 && role !== 5 && role !== 3) && hasPermission('viewuser') && <li>
                    <Link to="/user-company/list"><img src={`${process.env.PUBLIC_URL}/images/bx-user.png`} alt='' /> <span>Customer Management</span></Link>
                </li>}
                {(isNumberManagementPermission == true) && <li>
                    <Link to="/number-management"><img src={`${process.env.PUBLIC_URL}/images/phone-call.png`} alt='' /> <span>Number Management</span></Link>
                </li>}
                {role <= 2 && <li>
                    <Link to="/trunk-cron-list"><img src={`${process.env.PUBLIC_URL}/images/etns.png`} alt='' /><span>Trunk Sync Cron</span></Link>
                </li>}
                {casAccess && <li>
                    <Link to="/cas-management"><img src={`${process.env.PUBLIC_URL}/images/etns.png`} alt='' /><span>E-NRMS Dashboard</span></Link>
                </li>}
                {((callPassBrandedCallingAccess && userCallPassBrandedCallingAccess) || (callPassIdentitiesAccess && userCallPassIdentitiesAccess) || (role <= 2 && userCallPassExportAccess)) && (<li>
                    <Link to='/call-pass'><img src={`${process.env.PUBLIC_URL}/images/phone-call.png`} alt='' /><span>Call Pass - Branded Calling</span></Link>
                </li>)}
                {/* {(callPassBrandedCallingAccess  && userCallPassBrandedCallingAccess) && (
                    <li className={callPassSubmenuOpen ? 'submenu-open' : ''}>
                        <a href="#" onClick={(e) => { e.preventDefault(); setCallPassSubmenuOpen(!callPassSubmenuOpen); }}>
                            <img src={`${process.env.PUBLIC_URL}/images/phone-call.png`} alt='' />
                            <span>Call Pass - Branded Calling</span>
                        </a>
                        {callPassSubmenuOpen && (
                            <ul className="submenu">
                                <li>
                                    <Link to="/call-pass-summary"><span>Call Pass Summary</span></Link>
                                </li>
                                {callPassIdentitiesAccess && userCallPassIdentitiesAccess && <li>
                                    <Link to="/call-pass-display-identities"><span>Call Pass Display Identities</span></Link>
                                </li>}
                            </ul>
                        )}
                    </li>)} */}
                {hasUptivityAccess && <li>
                    <Link to="/uptivity"><img src={`${process.env.PUBLIC_URL}/images/etns.png`} alt='' /><span>Uptivity</span></Link>
                </li>}
                {hasUptivityAccess && <li>
                    <Link to="/citibank-uptivity"><img src={`${process.env.PUBLIC_URL}/images/etns.png`} alt='' /><span>Citibank Uptivity</span></Link>
                </li>}
                {/* {applicationList.length > 0 && applicationList.map((item, index) => (
                    
                    <li key={index}>
                        <a href="#" onClick={(e) => {handleApplication(e, item.url)}}>
                            <img src={item.logo ? `${apiUrl}/${item.logo}` : `${process.env.PUBLIC_URL}/images/etns.png`} alt='' width="30" height="30" /><span>{item.name}</span>
                        </a>
                    </li>
                    
                ))} */}

                {applicationList.length > 0 && (
                    applicationList.map((item, index) => 
                        userApplicationList.includes(item.id) ? ( 
                            <li key={index}>
                                <a href="#" onClick={(e) => handleApplication(e, item.url)}>
                                    <img 
                                        src={item.logo ? `${apiUrl}/${item.logo}` : `${process.env.PUBLIC_URL}/images/etns.png`} 
                                        alt='' width="30" height="30" 
                                    />
                                    <span>{item.name}</span>
                                </a>
                            </li>
                        ) : null
                    )
                )}


                {/* {( role == 3 || role == 4 || (role == 5 && hasPermission('viewuser'))) && <li>
                    <Link to={`/current-config/${props.token}`}><img src={`${process.env.PUBLIC_URL}/images/settings.png`} /> Current Config</Link>
                </li>} */}
                <li>
                    <a href="#" onClick={(e) => { e.preventDefault(); Logout(); }}><img src={`${process.env.PUBLIC_URL}/images/logout.png`} alt='' /> <span>Log out</span></a>
                </li>
            </ul>
        </div>
        {!mobileMenuOpen && <div className="mobilemenu" onClick={toggleMobileMenu}>
            <a href="#"><img src={`${process.env.PUBLIC_URL}/images/menubar.png`} alt='' /></a>
        </div>}
        {iframeUrl && (
            <div className="iframe-wrap" >
                <iframe 
                    src={iframeUrl}
                    className="iframe"
                    
                    title="Fullscreen Iframe"
                />
                {/* <a 
                    onClick={closeIframe} 
                    className='iframe-close'
                    >
                    <img src={`${process.env.PUBLIC_URL}/images/bx-x-circle.png`}  alt="Close" title="Close" />
                </a> */}
            </div>
        )}
    </div>
    
    )
}
 
export default Navbar